<div class="flex flex-col items-center">
    <div class="flex justify-center">
        <span
            class="malou-text-42--bold md:malou-text-28--bold text-color-text-title text-center font-passion-one uppercase md:leading-tight">
            <span [innerHTML]="'maloupe.diagnostic_header.title' | translate"></span>
            <span class="relative">
                <mat-icon
                    class="absolute bottom-6 right-[-26px] !h-10 !w-10 text-malou-pink md:bottom-3.5 md:right-[-16px] md:!h-7 md:!w-7"
                    [svgIcon]="SvgIcon.SPARKLES"></mat-icon>
            </span>
        </span>
    </div>
    <div class="malou-text-18--regular md:malou-text-16--regular text-center text-malou-text md:mt-2">
        {{ subtitle() }}
    </div>
</div>
